import { render, staticRenderFns } from "./GOptionalData.vue?vue&type=template&id=2fbb222b&scoped=true&"
import script from "./GOptionalData.vue?vue&type=script&lang=ts&"
export * from "./GOptionalData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb222b",
  null
  
)

export default component.exports